// Portal <-> Extension bridge contract.
//
// The Cricket Studio browser extension exposes a set of window-level custom
// events that the portal can dispatch/listen for. These run through the
// content script (see apps/extension/src/content/index.ts) and map to
// `chrome.runtime.sendMessage` calls handled by the background service worker.
//
// Keep the event names and payload shapes here so both ends stay aligned.
export const DATA_ATTR_EXTENSION_INSTALLED = 'data-cricket-studio-extension';
export const EVENT_EXTENSION_READY = 'cricket-studio-extension-ready';
export const EVENT_EXTENSION_HEARTBEAT = 'cricket-studio-extension-heartbeat';
export const EVENT_ARM_RECORDING = 'cricket-studio:arm-recording';
export const EVENT_ARM_RECORDING_ACK = 'cricket-studio:arm-recording-ack';
export const EVENT_CLEAR_ARMED_RECORDING = 'cricket-studio:clear-armed-recording';
export const EVENT_PAIR_EXTENSION_SESSION = 'cricket-studio:pair-extension-session';
export const EVENT_PAIR_EXTENSION_SESSION_ACK = 'cricket-studio:pair-extension-session-ack';
export const EVENT_UNPAIR_EXTENSION_SESSION = 'cricket-studio:unpair-extension-session';
export const EVENT_STOP_RECORDING = 'cricket-studio:stop-recording';
export const EVENT_STOP_RECORDING_ACK = 'cricket-studio:stop-recording-ack';
export const EVENT_REQUEST_RECORDING_SNAPSHOT = 'cricket-studio:request-recording-snapshot';
export const EVENT_RECORDING_SNAPSHOT = 'cricket-studio:recording-snapshot';
export const EVENT_RECORDING_STATE = 'cricket-studio:recording-state';
// Type guards ---------------------------------------------------------------
const DEPARTMENTS_ALLOWED = ['retail', 'call_center', 'corporate'];
const USER_ROLES_ALLOWED = ['agent', 'manager', 'admin', 'other'];
export function isArmRecordingPayload(value) {
    if (!value || typeof value !== 'object')
        return false;
    const record = value;
    const department = record.department;
    const category = record.category;
    const userRole = record.userRole;
    const uploadToken = record.uploadToken;
    if (typeof department !== 'string' || !DEPARTMENTS_ALLOWED.includes(department)) {
        return false;
    }
    if (typeof category !== 'string' || category.length === 0)
        return false;
    if (typeof userRole !== 'string' || !USER_ROLES_ALLOWED.includes(userRole)) {
        return false;
    }
    if (uploadToken !== undefined && typeof uploadToken !== 'string') {
        return false;
    }
    return true;
}
function isPairedExtensionUser(value) {
    if (!value || typeof value !== 'object')
        return false;
    const record = value;
    return (typeof record.id === 'string' &&
        record.id.length > 0 &&
        typeof record.name === 'string' &&
        typeof record.email === 'string' &&
        typeof record.role === 'string');
}
export function isPairExtensionSessionPayload(value) {
    if (!value || typeof value !== 'object')
        return false;
    const record = value;
    return (typeof record.sessionToken === 'string' &&
        record.sessionToken.length > 0 &&
        typeof record.expiresAt === 'string' &&
        Number.isFinite(Date.parse(record.expiresAt)) &&
        isPairedExtensionUser(record.user));
}
export function isFlowOutcome(value) {
    if (!value || typeof value !== 'object')
        return false;
    const record = value;
    const result = record.result;
    if (result !== 'success' && result !== 'failed' && result !== 'partial')
        return false;
    if (record.reason !== undefined && typeof record.reason !== 'string')
        return false;
    return true;
}
